import { ReactComponent as Heading1Icon } from "./heading1.svg";
import { ReactComponent as Heading2Icon } from "./heading2.svg";
import { ReactComponent as LinkIcon } from "./link.svg";
import { ReactComponent as ListOrderedIcon } from "./list-ordered.svg";
import { ReactComponent as ListUnOrderedIcon } from "./list-unordered.svg";
import { ReactComponent as BoldIcon } from "./bold.svg";
import { ReactComponent as QuestionCircleIcon } from "./question-circle.svg";
import { ReactComponent as SearchIcon } from "./search.svg";
import { ReactComponent as PcIcon } from "./pc.svg";
import { ReactComponent as TagIcon } from "./tag.svg";
import { ReactComponent as AnnouncementIcon } from "./announcement.svg";
import { ReactComponent as BookmarkIcon } from "./bookmark.svg";
import { ReactComponent as CommentIcon } from "./comment.svg";
import { ReactComponent as MailIcon } from "./mail.svg";
import { ReactComponent as PaperIcon } from "./paper.svg";
import { ReactComponent as SecurityIcon } from "./security.svg";
import { ReactComponent as StartCircleIcon } from "./start-circle.svg";
import { ReactComponent as TutorialIcon } from "./tutorial.svg";
import { ReactComponent as InfoCircleIcon } from "./info-circle.svg";
import { ReactComponent as ListSettingIcon } from "./list-setting.svg";
import { ReactComponent as PlusCircleIcon } from "./plus-circle.svg";
import { ReactComponent as SettingIcon } from "./setting.svg";
import { ReactComponent as SmartApplyIcon } from "./smartapply.svg";

export const Icons = {
  Heading1Icon,
  Heading2Icon,
  LinkIcon,
  ListOrderedIcon,
  ListUnOrderedIcon,
  BoldIcon,
  QuestionCircleIcon,
  SearchIcon,
  PcIcon,
  TagIcon,
  AnnouncementIcon,
  BookmarkIcon,
  CommentIcon,
  MailIcon,
  PaperIcon,
  SecurityIcon,
  StartCircleIcon,
  TutorialIcon,
  InfoCircleIcon,
  ListSettingIcon,
  PlusCircleIcon,
  SettingIcon,
  SmartApplyIcon,
};
